<template>
  <div>
    <div class="demo-tab-panel">
      <div class="demo-title">两项</div>
      <div class="bx-tab-container bx-tab-two">
      <div class="bx-tab">
        <div class="bx-tab-wrap">
          <div class="bx-tab-item">
            <div class="bx-tab-text">分类一</div>
          </div>
          <div class="bx-tab-item">
            <div class="bx-tab-text">分类二</div>
          </div>
        </div>
        <div class="bx-tab-line"></div>
      </div>
      <div class="bx-tab-contents">
        <div class="bx-tab-scroller">
          <div class="bx-tab-content">
            <p>分类一内容</p>
            <p>分类一内容</p>
            <p>分类一内容</p>
          </div>
          <div class="bx-tab-content">
            <p>分类二内容</p>
            <p>分类二内容</p>
            <p>分类二内容</p>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="demo-tab-panel">
      <div class="demo-title">三项(内容高度不一致)</div>
      <div class="bx-tab-container bx-tab-three">
      <div class="bx-tab">
        <div class="bx-tab-wrap">
          <div class="bx-tab-item">
            <div class="bx-tab-text">分类一</div>
          </div>
          <div class="bx-tab-item">
            <div class="bx-tab-text">分类二</div>
          </div>
          <div class="bx-tab-item">
            <div class="bx-tab-text">分类三</div>
          </div>
        </div>
        <div class="bx-tab-line"></div>
      </div>
      <div class="bx-tab-contents">
        <div class="bx-tab-scroller">
          <div class="bx-tab-content">
            <p>分类一内容</p>
            <p>分类一内容</p>
            <p>分类一内容</p>
          </div>
          <div class="bx-tab-content">
            <p>分类二内容</p>
            <p>分类二内容</p>
            <p>分类二内容</p>
          </div>
          <div class="bx-tab-content">
            <p>分类三内容</p>
            <p>分类三内容</p>
            <p>分类三内容</p>
            <p>分类三内容</p>
            <p>分类三内容</p>
            <p>分类三内容</p>
            <p>分类三内容</p>
            <p>分类三内容</p>
            <p>分类三内容</p>
            <p>分类三内容</p>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="demo-tab-panel">
      <div class="demo-title">四项</div>
      <div class="bx-tab-container bx-tab-four">
        <div class="bx-tab">
          <div class="bx-tab-wrap">
            <div class="bx-tab-item">
              <div class="bx-tab-text">分类一</div>
            </div>
            <div class="bx-tab-item">
              <div class="bx-tab-text">分类二</div>
            </div>
            <div class="bx-tab-item">
              <div class="bx-tab-text">分类三</div>
            </div>
            <div class="bx-tab-item">
              <div class="bx-tab-text">分类四</div>
            </div>
          </div>
          <div class="bx-tab-line"></div>
        </div>
        <div class="bx-tab-contents">
          <div class="bx-tab-scroller">
            <div class="bx-tab-content">
              <p>分类一内容</p>
              <p>分类一内容</p>
              <p>分类一内容</p>
              <p>分类一内容</p>
              <p>分类一内容</p>
              <p>分类一内容</p>
              <p>分类一内容</p>
              <p>分类一内容</p>
              <p>分类一内容</p>
            </div>
            <div class="bx-tab-content">
              <p>分类二内容</p>
              <p>分类二内容</p>
              <p>分类二内容</p>
              <p>分类二内容</p>
              <p>分类二内容</p>
              <p>分类二内容</p>
              <p>分类二内容</p>
              <p>分类二内容</p>
              <p>分类二内容</p>
              <p>分类二内容</p>
            </div>
            <div class="bx-tab-content">
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
              <p>分类三内容</p>
            </div>
            <div class="bx-tab-content">
              <p>分类四内容</p>
              <p>分类四内容</p>
              <p>分类四内容</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="demo-tab-panel">
      <div class="demo-title">五项(禁止滑动,取消页面滑动切换)</div>
      <div class="bx-tab-container bx-tab-five">
      <div class="bx-tab">
        <div class="bx-tab-wrap">
          <div class="bx-tab-item">
            <div class="bx-tab-text">降级处理</div>
          </div>
          <div class="bx-tab-item">
            <div class="bx-tab-text">关闭滑动</div>
          </div>
          <div class="bx-tab-item">
            <div class="bx-tab-text">防止低端</div>
          </div>
          <div class="bx-tab-item">
            <div class="bx-tab-text">手机切换</div>
          </div>
          <div class="bx-tab-item">
            <div class="bx-tab-text">延迟卡顿</div>
          </div>
        </div>
        <div class="bx-tab-line"></div>
      </div>
      <div class="bx-tab-contents">
        <div class="bx-tab-scroller" style="padding: 15px 15px;">
          <div class="bx-tab-content">
            <p>分类一内容</p>
            <p>分类一内容</p>
            <p>分类一内容</p>
          </div>
          <div class="bx-tab-content">
            <p>分类二内容</p>
            <p>分类二内容</p>
            <p>分类二内容</p>
          </div>
          <div class="bx-tab-content">
            <p>分类三内容</p>
            <p>分类三内容</p>
            <p>分类三内容</p>
          </div>
          <div class="bx-tab-content">
            <p>分类四内容</p>
            <p>分类四内容</p>
            <p>分类四内容</p>
          </div>
          <div class="bx-tab-content">
            <p>分类五内容</p>
            <p>分类五内容</p>
            <p>分类五内容</p>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="demo-tab-panel">
      <div class="demo-title">异步获取数据</div>
      <div class="bx-tab-container bx-tab-six">
      <div class="bx-tab">
        <div class="bx-tab-wrap">
          <div class="bx-tab-item">
            <div class="bx-tab-text">固定内容</div>
          </div>
          <div class="bx-tab-item">
            <div class="bx-tab-text">异步获取</div>
          </div>
          <div class="bx-tab-item">
            <div class="bx-tab-text">异步获取</div>
          </div>
          <div class="bx-tab-item">
            <div class="bx-tab-text">异步获取</div>
          </div>
        </div>
        <div class="bx-tab-line"></div>
      </div>
      <div class="bx-tab-contents">
        <div class="bx-tab-scroller">
          <div class="bx-tab-content">
            <p>固定内容</p>
            <p>固定内容</p>
            <p>固定内容</p>
            <p>固定内容</p>
            <p>固定内容</p>
            <p>固定内容</p>
            <p>固定内容</p>
          </div>
          <div class="bx-tab-content">
            <p>{{product.name}}</p>
            <p>{{product.name}}</p>
            <p>{{product.name}}</p>
            <p>{{product.name}}</p>
            <p>{{product.name}}</p>
            <p>{{product.name}}</p>
          </div>
          <div class="bx-tab-content">
            <p>{{desc.name}}</p>
            <p>{{desc.name}}</p>
            <p>{{desc.name}}</p>
            <p>{{desc.name}}</p>
            <p>{{desc.name}}</p>
            <p>{{desc.name}}</p>
            <p>{{desc.name}}</p>
          </div>
          <div class="bx-tab-content">
            <p>{{person.name}}</p>
            <p>{{person.name}}</p>
            <p>{{person.name}}</p>
            <p>{{person.name}}</p>
            <p>{{person.name}}</p>
            <p>{{person.age}}</p>
            <p>{{person.age}}</p>
            <p>{{person.age}}</p>
            <p>{{person.age}}</p>
            <p>{{person.age}}</p>
            <p>{{person.age}}</p>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="demo-tab-panel">
      <div class="demo-title">单个内容,异步获取数据变更内容</div>
      <div class="bx-tab-container bx-tab-single">
        <div class="bx-tab">
          <div class="bx-tab-wrap">
            <div class="bx-tab-item">
              <div class="bx-tab-text">异步获取</div>
            </div>
            <div class="bx-tab-item">
              <div class="bx-tab-text">异步获取</div>
            </div>
            <div class="bx-tab-item">
              <div class="bx-tab-text">异步获取</div>
            </div>
          </div>
          <div class="bx-tab-line"></div>
        </div>
        <div class="bx-tab-contents">
          <div class="bx-tab-scroller">
            <div class="bx-tab-content">
              <div v-for="item in list">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Tab from '@packages/components/tab/tab'
  import Loading from '@packages/components/loading/loading'
  export default {
    data () {
      return {
        person: {
          name: 'tomy'
        },
        product: {
          name: ''
        },
        desc: {
          name: ''
        },
        list: []
      }
    },
    mounted: function () {
      var self = this;
      this.$nextTick(function () {
        // eslint-disable-next-line
        new Tab('.bx-tab-two', {});
        // eslint-disable-next-line
        new Tab('.bx-tab-three', {
          activeIndex: 1
        });
        // eslint-disable-next-line
        new Tab('.bx-tab-four', {});
        // eslint-disable-next-line
        new Tab('.bx-tab-five', {
          slide: false,
          transition: false
        });
        // eslint-disable-next-line
        new Tab('.bx-tab-six', {
          lineWidth: 15,
          onInit: function () {
            console.log('onInit');
          },
          onSlidePrev: function () {
            console.log('onSlidePrev');
          },
          onSlideNext: function () {
            console.log('onSlideNext');
          },
          onChange: function (index) {
            console.log('onChange', index);
            switch (index) {
              case 0:
                break;
              case 1:
                self.getProduct();
                break;
              case 2:
                self.getDesc();
                break;
              case 3:
                self.getPerson();
                break;
            }
          },
          onItemClick: function (index) {
            console.log('onItemClick', index);
          }
        });
        // eslint-disable-next-line
        new Tab('.bx-tab-single', {
          onChange: function (index) {
            switch (index) {
              case 0:
                self.getList1();
                break;
              case 1:
                self.getList2();
                break;
              case 2:
                self.getList3();
                break;
            }
          }
        });
      });
    },
    methods: {
      getPerson () {
        var self = this;
        Loading.show();
        window.setTimeout(function () {
          self.person.name = 'jerry';
          self.person.age = '23岁';
          Loading.hide();
        }, 500);
      },
      getProduct () {
        var self = this;
        Loading.show();
        window.setTimeout(function () {
          self.product.name = 'mac';
          Loading.hide();
        }, 500);
      },
      getDesc () {
        var self = this;
        Loading.show();
        window.setTimeout(function () {
          self.desc.name = '介绍';
          Loading.hide();
        }, 500);
      },
      getList1 () {
        var self = this;
        Loading.show();
        window.setTimeout(function () {
          var item = {};
          item.name = '内容一';
          self.list = [];
          self.list.push(item);
          self.list.push(item);
          self.list.push(item);
          Loading.hide();
        }, 500);
      },
      getList2 () {
        var self = this;
        Loading.show();
        window.setTimeout(function () {
          var item = {};
          item.name = '内容二';
          self.list = [];
          self.list.push(item);
          self.list.push(item);
          self.list.push(item);
          Loading.hide();
        }, 500);
      },
      getList3 () {
        var self = this;
        Loading.show();
        window.setTimeout(function () {
          var item = {};
          item.name = '内容三';
          self.list = [];
          self.list.push(item);
          self.list.push(item);
          self.list.push(item);
          Loading.hide();
        }, 500);
      }
    }
  }
</script>
<style scoped>
  .demo-tab-panel{
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Tab.vue